import React from 'react';

import Fact from './Fact';
import Vilseledande from '../Information/Vilseledande';

function HoC(props) {
  return (
    <Fact id="vilseledande" title="Vilseledande" {...props}>
      <p>
        {`
          När du ska bestämma om den produkt och det kostråd du tänkt
          kombinera kan användas är det viktigt att bedöma om kombinationen
          är vilseledande eller ej.
        `}
      </p>
      <p>
        {`
          Livsmedel som märks med ett av Livsmedelsverkets kostråd får inte vilseleda konsumenten när det gäller:
        `}
      </p>
      <ul>
        <li>livsmedlets nyttighet som helhet</li>
        <li>hur kostrådet formulerats</li>
        <li>om kostrådet speglar livsmedlets innehåll</li>
      </ul>
      <p>
        {`
          Regleringen av vilseledande finns i artikel 7 i EU-förordning
          1169/2011, se nedan.
        `}
      </p>
      <Vilseledande />
    </Fact>
  );
}

export default HoC;



// WEBPACK FOOTER //
// ./src/components/Fact/FactVilseledande.js